import { render, staticRenderFns } from "./name.vue?vue&type=template&id=0b1d65ed&scoped=true&"
import script from "./name.vue?vue&type=script&lang=js&"
export * from "./name.vue?vue&type=script&lang=js&"
import style0 from "./name.vue?vue&type=style&index=0&id=0b1d65ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1d65ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1d65ed')) {
      api.createRecord('0b1d65ed', component.options)
    } else {
      api.reload('0b1d65ed', component.options)
    }
    module.hot.accept("./name.vue?vue&type=template&id=0b1d65ed&scoped=true&", function () {
      api.rerender('0b1d65ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckylogin/validation/name.vue"
export default component.exports